import React from 'react';
import styles from './region-table.module.scss';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import { setActivePage } from '../../actions/ui';
import TableScroll from './table-scroll';
import { numberWithCommas } from '../../helpers/formatters';

const RegionTableComponent = ({ isMobile, dams }) => {
  const damCols = [
    {
      header: 'Dam name',
      key: 'dam',
    },
    {
      header: 'Dam owner',
      key: 'owner',
    },
    { header: 'Capacity (ML)', key: 'capacity' },
    { header: 'Current volume (ML)', key: 'currentVolume' },
    {
      header: 'Population at risk',
      key: 'populationAtRisk',
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '100%', overflow: 'auto' }}>
        <table className={styles.entityRegionTable}>
          <tbody>
            <tr>
              <td colSpan={isMobile ? 1 : 2}>
                <div className={styles.tableHeaderText}>In this region</div>
              </td>
            </tr>
            {dams.length > 0 ? (
              damCols && (
                <tr className={styles.regionTableHeaderRow}>
                  {damCols.map((c) => (
                    <td key={`header-${c.key}`}>{c.header}</td>
                  ))}
                </tr>
              )
            ) : (
              <tr className={styles.regularTableRow}>
                <td>
                  There are no regulated dams in this local government area.
                </td>
              </tr>
            )}
            {dams.map((e, i) => {
              return (
                <tr className={styles.regularTableRow} key={e + i}>
                  {damCols.map((c) => {
                    const value = e[c.key];
                    return (
                      <td key={c.key} style={{ minWidth: c.minWidth }}>
                        {numberWithCommas(value)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isMobile && dams.length > 0 && <TableScroll />}
    </div>
  );
};

const mapDispatchToProps = {
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

RegionTableComponent.propTypes = {
  region: PropTypes.object,
  dams: PropTypes.arrayOf(PropTypes.object),
  setActivePage: PropTypes.func,
};

const RegionTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionTableComponent);
export { RegionTable };



// WEBPACK FOOTER //
// ./src/components/region-table/region-table.js